module.exports = __webpack_public_path__ + "static/media/bg_about_game@2x.51115b12.png";